import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCorporate } from "sr/utils/api/corporate/getCorporate";

export const fetchCorporate = createAsyncThunk(
  "corporate/fetchCorporate",
  async (params: any, { rejectWithValue }) => {
    try {
      const result = await getCorporate(params?.id);
      if (result) {
        return result?.data?.corporate;
      } else {
        return rejectWithValue("Corporate not found");
      }
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch corporate");
    }
  }
);

interface CorporateState {
  data: any;
  isLoading: boolean;
  isError: boolean;
}

const initialState: CorporateState = {
  isLoading: false,
  data: null,
  isError: false,
};

const CorporateSlice = createSlice({
  name: "corporate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCorporate.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(fetchCorporate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchCorporate.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export default CorporateSlice.reducer;
